// router.js
import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'login',
            meta: { title: '登录' },
            component: () => import('@/pages/login')
        },
        {
            path: '/home',
            name: 'home',
            meta: { title: '首页' },
            component: () => import('@/pages/home'),
            children: [
                {
                    path: '/homeReport',
                    name: 'homeReport',
                    meta: { title: '首页统计' },
                    component: () => import('@/pages/homeReport')
                },
                {
                    path: '/buyTicket',
                    name: 'buyTicket',
                    meta: { title: '购票' },
                    component: () => import('@/pages/buyTicket')
                },
                {
                    path: '/buyTickets',
                    name: 'buyTickets',
                    meta: { title: '团队票' },
                    component: () => import('@/pages/buyTickets')
                },
                {
                    path: '/buyTime',
                    name: 'buyTime',
                    meta: { title: '计时' },
                    component: () => import('@/pages/buyTime')
                },
                {
                    path: '/annualPass',
                    name: 'annualPass',
                    meta: { title: '年卡' },
                    component: () => import('@/pages/annualPass')
                },
                {
                    path: '/smartCard',
                    name: 'smartCard',
                    meta: { title: '一卡通' },
                    component: () => import('@/pages/smartCard')
                },
                {
                    path: '/afterSales',
                    name: 'afterSales',
                    meta: { title: '售后' },
                    component: () => import('@/pages/afterSales')
                },
                {
                    path: '/member',
                    name: 'member',
                    meta: { title: '会员' },
                    component: () => import('@/pages/member')
                },
                {
                    path: '/reportForms',
                    name: 'reportForms',
                    meta: { title: '报表' },
                    component: () => import('@/pages/reportForms')
                },
                {
                    path: '/setUp',
                    name: 'setUp',
                    meta: { title: '设置' },
                    component: () => import('@/pages/setUp')
                },
            ]
        },
        {
            path: '/paySuccess',
            name: 'paySuccess',
            meta: { title: '支付成功' },
            component: () => import('@/pages/paySuccess')
        },
        // 默认重定向
        {
            path: '*',
            redirect: '/login'
        }
    ]
});

router.beforeEach((to, from, next) => {
    console.log(to,from)
    if(to.path == '/'){
        if(localStorage.getItem('token')){
            next({path: '/home'})
        }else{
            next();
        }
    }else{
        next();
    }
});

export default router;